// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HA5R","newExpiryDate":"styles_newExpiryDate__3mkFH","footer":"styles_footer__2JQTJ"};